import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash'
import { FormattedMessage } from 'react-intl'
import { Modal } from 'containers/misc'
import { PersonLoginChange } from 'containers/forms/person'
import { Button, FormData, InfoPanel } from 'components/misc'
import { Input } from 'components/fields'
import { Span } from 'components/layout'
import { apiPersons } from 'helpers/decorators/api'
import { PERSON_STATES } from 'constants/enums'

@apiPersons({
  readParams: 'ADDRESS,AWARD_LEADER_PROFILE,AWARD_LEADERSHIP_HISTORY'
})
class PersonEmail extends Component {
  static propTypes = {
    label: PropTypes.string,
    intlKey: PropTypes.string,
    name: PropTypes.string,
    disabled: PropTypes.bool,
    modal: PropTypes.func.isRequired,
    changePersonLogin: PropTypes.func.isRequired,
    personState: PropTypes.object,
    user: PropTypes.object,
    migratedEmail: PropTypes.string,
    canChangeEmail: PropTypes.bool,
    personId: PropTypes.number
  }
  static defaultProps = {
    label: 'Email',
    intlKey: 'label.email',
    name: 'email',
    disabled: false,
    personState: {},
    canChangeEmail: false
  }

  render() {
    const {
      label,
      intlKey,
      name,
      disabled,
      personState,
      migratedEmail,
      canChangeEmail,
      personId,
      user
    } = this.props
    const emailColClass = canChangeEmail ? 'col-xs-9' : 'col-xs-12'
    const isSelf = get(user, 'personId') === personId

    return (
      <div>
        <div className="row">
          <div className={emailColClass}>
            <Input
              label={label}
              intlKey={intlKey}
              name={name}
              readonly={disabled}
            />
          </div>
          {canChangeEmail && (
            <div className="col-xs-3">
              <Button
                type="button"
                justify
                secondary
                onClick={() => this.props.modal('modal-change-person-email')}
                fluid
                intlKey="button.change"
                disabled={
                  get(personState, 'value') === PERSON_STATES.inactive.id
                }
              >
                Change
              </Button>
            </div>
          )}
        </div>
        {migratedEmail && (
          <div>
            <FormData
              label="Migrated Contact email"
              intlKey="label.migrated_contact_email"
            >
              {migratedEmail}
              <InfoPanel offsetTop>
                <FormattedMessage
                  id="note.change_the_email_will_change"
                  defaultMessage="Note: Changing the Email will change also the Migrated Contact email"
                />
              </InfoPanel>
            </FormData>
          </div>
        )}
        <Modal id="modal-change-person-email" customActions>
          {isSelf && (
            <div className="row">
              <div className="col-xs-12">
                <div className="base-margin--bottom">
                  <Span
                    error
                    intlKey="label.you_will_be_forced_to_login_again_after_change"
                  >
                    You will be forced to login again after change
                  </Span>
                </div>
              </div>
            </div>
          )}
          <PersonLoginChange
            changePersonLogin={fields =>
              this.props.changePersonLogin(personId, fields, {
                isSelf
              })
            }
          />
        </Modal>
      </div>
    )
  }
}

export default PersonEmail
